import { render, staticRenderFns } from "./AssignedGenerationsSection.vue?vue&type=template&id=4641548c&scoped=true"
import script from "./AssignedGenerationsSection.vue?vue&type=script&lang=ts"
export * from "./AssignedGenerationsSection.vue?vue&type=script&lang=ts"
import style0 from "./AssignedGenerationsSection.vue?vue&type=style&index=0&id=4641548c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4641548c",
  null
  
)

export default component.exports